import loki from 'lokijs';
import lokiIndexedAdapter from 'lokijs/src/loki-indexed-adapter';

const {
  NODE_ENV,
  LOKI_DB_NAME,
} = process.env;

const isTest = NODE_ENV === 'test';

export function getLokiDb(collectionName, callback = undefined) {
  return new Promise((resolve) => {
    const adapter = isTest
      ? new loki.LokiMemoryAdapter()
      : new lokiIndexedAdapter();

    const db = new loki(`${LOKI_DB_NAME || 'swell'}.db`, {
      adapter,
      autoload: true,
      autoloadCallback: function () {
        let collection = db.getCollection(collectionName);

        if (!collection) {
          collection = db.addCollection(collectionName);
        }

        if (callback) {
          callback(collection);
        }

        resolve(collection);
      },
      autosave: true,
      autosaveInterval: 4000,
    });
  });
}